import { IPermissions } from 'types';

/**
 * Check if user has permission to manage the library (LIBRARY_MANAGE).
 * This is the highest-level admin permission.
 */
export const canManageLibrary = (permissions: IPermissions): boolean => {
  return permissions.canManage === true;
};

/**
 * Check if user has permission to view the library (LIBRARY_USE).
 */
export const canViewLibrary = (permissions: IPermissions): boolean => {
  return permissions.canUse === true;
};

/**
 * Check if user has permission to create categories (LIBRARY_CATEGORY_CREATE).
 */
export const canCreateCategory = (permissions: IPermissions): boolean => {
  return permissions.canCreateCategory;
};

/**
 * Check if user has permission to modify categories (LIBRARY_CATEGORY_MODIFY).
 */
export const canModifyCategory = (permissions: IPermissions): boolean => {
  return permissions.canModifyCategory;
};

/**
 * Check if user has permission to delete categories (LIBRARY_CATEGORY_DELETE).
 */
export const canDeleteCategory = (permissions: IPermissions): boolean => {
  return permissions.canDeleteCategory;
};

/**
 * Check if user has permission to create resources (LIBRARY_RESOURCE_CREATE).
 */
export const canCreateResource = (permissions: IPermissions): boolean => {
  return permissions.canCreateResource;
};

/**
 * Check if user has permission to modify resources (LIBRARY_RESOURCE_MODIFY).
 */
export const canModifyResource = (permissions: IPermissions): boolean => {
  return permissions.canModifyResource;
};

/**
 * Check if user has permission to delete resources (LIBRARY_RESOURCE_DELETE).
 */
export const canDeleteResource = (permissions: IPermissions): boolean => {
  return permissions.canDeleteResource;
};

/**
 * Check if user has permission to exclude locations (Library_Location_Exclude).
 */
export const canExcludeLocations = (permissions: IPermissions): boolean => {
  return permissions.canExcludeLocations;
};
